import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ExcelTableEditorComponent } from './excel-table-editor.component';

@NgModule({
  declarations: [ExcelTableEditorComponent],
  imports: [CommonModule, FormsModule],
  exports: [ExcelTableEditorComponent],
})
export class ExcelTableEditorModule {}
